import React from 'react'
import CardImg from '../assets/large_card.png'

const ProductCard = () => {
    return (
        <div className='bg-bgprimary rounded-md p-2' >
            <img src={CardImg} className='w-full mb-3' alt="" />
            <p className='text-dark font-quicksand font-medium text-[12px]' > LisLancashire</p>
        </div>
    )
}

export default ProductCard
